<div class="switcher-container">
    <div class="switch-loader d-flex align-items-center justify-content-center">
        <app-loader [showMessage]="false" loadingIconSize="spinner-grow-lg"></app-loader>
    </div>
</div>